export default __webpack_public_path__ + "static/media/item2.ed8a60a7.png";